import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { Container } from './Table';
import { fetchUserList } from '@app/src/views/Users/list/state/userList/actions';
import * as selectUserList from '@app/src/views/Users/list/state/userList/selectors';
import { getIdUser } from '@app/src/views/EditUser/editUser/state/filterValues/actions';

const mapStateToProps = state => ({
  items: selectUserList.getData(state),
  isFetching: selectUserList.getIsFetching(state),
  totalPages: selectUserList.getTotalPages(state),
  getTotalRow :selectUserList.getTotalRow(state),
  page: selectUserList.getPage(state),
  valuesForm: getFormValues('filterUser')(state)
});

const mapDispatchToProps = dispatch => ({
  getPage: (page: number, filter: object, url: string) => {
    dispatch(fetchUserList({ page, ...filter }, url));
  },
  handleGetIdUser: (idUser: number) => dispatch(getIdUser(idUser))
});

export const TableContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);
